<script setup lang="ts">
import { nav } from '@/data/megaMenuData'
const i18nService = usei18nService()
const localePath = useLocalePath()
const route = useRoute()
const { locale } = useI18n()

const { isMobile_lg, isTablet_lg } = useWindowWidth()

const isCurrentRoute = (to: string) => {
	if (to === route.name?.slice(0, -5)) return true
	return false
}

const redirectionLink = (to: string) => {
	if (to === 'blog') return '/pl/blog'
	return localePath(to)
}

const computedNav = computed(() => {
	return nav
		.map((item) => {
			if (item.translation_key_label === 'app') {
				return { ...item, to: `https://aplikacja.carfree.pl/${locale.value === 'pl' ? '' : 'en/home'}` }
			}
			return item
		})
		?.filter((item) => (item?.showOnlyOnPL ? locale.value === 'pl' : true))
		?.filter((item) => !['frequent_questions', 'news'].includes(item.translation_key_label))
})
</script>

<template>
	<nav class="nav">
		<NuxtLink class="nav__logo" :prefetch="false" :to="localePath('/')" aria-label="CarFree - strona główna">
			<GlobalIcon
				name="carfree-logo"
				alt="Logo strony CarFree wypożyczalnia samochodów"
				:width="isMobile_lg ? 74 : 94"
				:height="isMobile_lg ? 32 : 46" />
		</NuxtLink>
		<template v-for="(item, index) in computedNav" :key="index">
			<NuxtLink
				v-if="item.type === 'link'"
				:to="item.newTab === true ? item.to : redirectionLink(item.to)"
				class="nav__item"
				:rel="item.rel ? item.rel : undefined"
				:prefetch="false"
				:class="{ 'nav__item--active': isCurrentRoute(item.to) }"
				:target="item.newTab === true ? '_blank' : ''"
				>{{ i18nService.$tDynamic('components.nav', item.translation_key_label || item.label) }}</NuxtLink
			>
			<ClientOnly v-else-if="item.type === 'link-dropdown'">
				<LazyVisibleGlobalCarsMenu v-if="!isTablet_lg" :item="item" hydrate-on-visible />
			</ClientOnly>
			<ClientOnly v-else>
				<LazyVisibleGlobalMegaMenu v-if="!isTablet_lg" :item="item" hydrate-on-visible />
			</ClientOnly>
		</template>
	</nav>
</template>

<style lang="scss" src="./Nav.scss"></style>
